var MatildaAPIClient = new (require("wr_apis/apis/matilda_api/node_package/src/index.js")).Client("matilda.whooosreading.org", "https");

require('data/graphs/custom_tooltip')


// This class is used for as a custom tooltip in IndividualScoringGraph.js.
// Allows us to handle onClick behavior and display bookname, and completed_at for a given answer/quiz. 
class ScoringToolTip extends React.Component{
    constructor(props) {
		super();
		autobind(this);

        this.state = {
            loading: true,
            bookName: null
        }
    }

    render(){
        if (this.props.active && this.props.payload && this.props.payload.length) {
            var completedAt = new Date(_.find(this.props.payload, (metric)=> metric.dataKey = 'timeStamp').value[0])
            
            var tooltip = (
                <div className='mainContainer'>
                    {this.state.bookName ? 
                        <span> {this.state.bookName}</span> :
                        <i> Loading title </i>
                    }
                    {completedAt.toDateString()}
                    <i>click to view</i>
                </div>
            )
            
        } else {
            var tooltip = <p></p>
        }

        return tooltip
    }

    componentDidUpdate(prevProps){
        if (this.props.active && this.props.payload && this.props.payload.length && !prevProps.active) {
            var completedAt = _.find(this.props.payload, (metric)=> metric.dataKey = 'timeStamp').value[0]
            
            var completedAt = new Date(completedAt)
            var validWork = _.filter(this.props.data, datum=>(datum.evaluation))
            var selectedWork = _.find(validWork, (datum)=>{
                return _.isEqual(new Date(datum.evaluation.created_at), completedAt)
            })

            MatildaAPIClient.postScopedLookup("text_id", {'keys': selectedWork.text_id}).then(res=>{
                this.setState({bookName: res.results[[selectedWork.text_id]].title})
            })
        }
        
    }
}

module.exports = ScoringToolTip


// WEBPACK FOOTER //
// ./modules/components/data/graphs/ScoringToolTip.js